import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
const arrayMove = require('array-move');
const uuidv4 = require('uuid/v4');


const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: grid * 2,
  margin: `0 ${grid}px 0 0`,

  // change background colour if dragging
  //background: isDragging ? 'lightgreen' : 'grey',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = isDraggingOver => ({/*background: isDraggingOver ? 'lightblue' : 'lightgrey',*/padding: grid,overflow: 'auto',});

class CompleteWithText extends Component {

    constructor(props) {

        super(props);
        this.state = {};

        this.onDragEnd = this.onDragEnd.bind(this);
        this.add = this.add.bind(this);
        this.remove = this.remove.bind(this);

    }

    add(){

        this.props.state.dialogLesson.completewithtext.push({id:uuidv4(),text:'',answer:'',audio:''});
        this.setState({a:''});

    }

    remove(index){

        this.props.state.dialogLesson.completewithtext.splice(index,1);
        this.setState({a:''});

    }

    onDragEnd(data){
       
        this.props.state.dialogLesson.completewithtext = arrayMove(this.props.state.dialogLesson.completewithtext,data.source.index,data.destination.index);
        this.setState({a:""});

    }
    
    render() {

        var completewithtext = this.props.state.dialogLesson.completewithtext;
        if(completewithtext === undefined){

            this.props.state.dialogLesson.completewithtext = [];
            completewithtext = this.props.state.dialogLesson.completewithtext;

        }

        return (
        <React.Fragment>

            {

                (completewithtext.length === 0) &&
                <React.Fragment>
                    <center><h4>Nada foi cadastrado.</h4></center>
                </React.Fragment>

            }
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable" direction="vertical">
                {(provided, snapshot) => (
                    <div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)} {...provided.droppableProps} >
                    {
                    
                    completewithtext.map((item, index) => (
                            <Draggable key={item.id+''} draggableId={item.id+''} index={index}>
                                {(provided, snapshot) => (
                                    <div ref={provided.innerRef} {...provided.draggableProps}  style={getItemStyle(snapshot.isDragging,provided.draggableProps.style)} className="row">
                                        <div className="col-md-1" style={{display:'flex',justifyContent:'center',alignItems:'center'}}><i {...provided.dragHandleProps} style={{position:'absolute',top:'40px',left:'55px'}} className="fas fa-arrows-alt"></i></div>
                                        <div className="col-md-4">
                                            <h5>Texto:</h5>
                                            <input type="text" className="form-control-alternative form-control" value={item.text} onChange={(e) => { item.text = e.target.value; this.setState({a:''}); }}/>
                                        </div>
                                        <div className="col-md-4">
                                            <h5>Resposta:</h5>
                                            <input type="text" className="form-control-alternative form-control" value={item.answer} onChange={(e) => { item.answer = e.target.value; this.setState({a:''}); }}/>
                                        </div>
                                        <div className="col-md-2">
                                            <h5>Audio:</h5>
                                            <select type="text" className="form-control-alternative form-control" value={item.audio} onChange={(e) => { item.audio = e.target.value; this.setState({a:''}); }} >
                                                <option value="">{}</option>
                                                {

                                                    this.props.state.audios.map((value,index) => {

                                                        return(<option value={value.id}>{value.name}</option>)

                                                    })

                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-1" style={{display:'flex',justifyContent:'left'}}><i onClick={() => this.remove(index)} style={{cursor:'pointer',position:'absolute',top:'40px',left:'0px'}} className="far fa-trash-alt"></i></div>
                                    </div>
                                )}
                            </Draggable>
                        ))
                    
                    }
                    {provided.placeholder}
                    </div>
                )}
                </Droppable>
            </DragDropContext>

            <center><button style={{width:'130px'}} color="primary" onClick={() => this.add()} className="btn btn-sm btn-secondary"><i className="fas fa-plus"></i> Adicionar</button></center>

        </React.Fragment>
        );
    }

}

export default CompleteWithText;